import React, { Component } from 'react';
import Constants from '../../../definitions/constants';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import toastr from 'toastr';
import LocaleTooling from '../../../tooling/localeTooling';

import CheckBox from '../common/inputs/checkBox';

const MetricsEditor = props => {
  const {
    systemDimensionMetrics,
    selectedMetrics,
    onChange
  } = props;
  const dataPath = props["data-path"];
  return (
    <div className={"custom-input free-text-list select-list metrics-editor select-list-no-search" }>
      <div className="free-text-list-label">
        {LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="biTemplateAdmin.fields.system_dimension_metrics"/>)}
      </div>
      <div className="free-text-list-list-wrapper">
        {systemDimensionMetrics && systemDimensionMetrics.map((item,i) => {
          return (
            <div key={i} className="free-text-list-list-item">
              <div className="free-text-list-list-item-inner">
                {item.metric_name}
                <CheckBox 
                  data-metriceditor={"true"}
                  value={selectedMetrics.includes(item.metric_id)}
                  data-path={item.metric_id}
                  onChange={onChange}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
          
export default MetricsEditor;
              


// WEBPACK FOOTER //
// ./source/client/components/biTemplateAdmin/metricsEditor.jsx